import React, { useRef, useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";

const Documents = () => {
  const { baseUrl, selectedStaff, openToast } = useGlobalContext();
  const [staff, setStaff] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [uploadFileType, setUploadFileType] = useState("");
  const fileUploadTypes = [
    { name: "Aadhaar", file: "aadhaar" },
    { name: "Pan", file: "pan" },
    { name: "Driving License", file: "driving_license" },
    { name: "Voter ID", file: "voter_id" },
    { name: "UAN", file: "uan" },
    { name: "Address", file: "address" },
  ];

  const [documents, setDocuments] = useState([
    {
      type: "Salary Slip",
      fileName: "Salary Slip",
      isFolder: true,
      addedOn: null,
      data: "",
    },
    // {
    //   type: "Degree",
    //   fileName: "Screenshot 2024-11-07 103717.png",
    //   isFolder: false,
    //   addedOn: "12 Nov 2024",

    // },
  ]);
  console.log(documents?.filter(({ data, isFolder }) => !isFolder && data));
  function formattedDate(isoDate) {
    const date = new Date(isoDate);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-IN", options);
  }

  const getData = async (e) => {
    setIsLoadingData(true);
    try {
      const response = await fetch(baseUrl + "staff/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        // console.log(result);
        const filteredData = result?.find(
          (item) => item?.id === selectedStaff?.id
        );
        setStaff(filteredData);
        console.log(
          "Filtered data by ID:",
          filteredData?.staffDetails?.staff_bg_verification
        );
        // console.log();
        setDocuments([
          ...documents.filter(({ isFolder }) => isFolder === true),
          ...fileUploadTypes.map((item) => ({
            type: item.name,
            fileName: item.name + " File",
            isFolder: false,
            addedOn: formattedDate(
              filteredData?.staffDetails?.staff_bg_verification?.updatedAt
            ),
            data: filteredData?.staffDetails?.staff_bg_verification?.[
              item?.file + `_file`
            ],
          })),
        ]);
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    } finally {
      setIsLoadingData(false);
    }
  };

  function downloadFile(url, filename) {
    // Check if URL is valid
    if (!url) {
      console.error("URL is required for downloading the file.");
      return;
    }

    // Create an anchor element
    const anchor = document.createElement("a");

    // Handle potential CORS issues (using Blob if necessary)
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        anchor.href = blobUrl;
        anchor.target = "_blank";
        anchor.download = filename || "downloaded_file";

        // Append the anchor element to the body and trigger the download
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        // Revoke the object URL after download to release resources
        URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
        console.error("There was an error with the file download:", error);
      });
  }

  useEffect(() => {
    getData();
  }, []);

  const fileInputRef = useRef(null);

  // Function to handle button click and open file input dialog
  const handleUploadClick = () => {
    fileInputRef.current.click(); // Trigger click on input type="file"
  };

  // Function to handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    setUploadFile(file);
    console.log("Selected file:", file);
  };

  const [uploadFile, setUploadFile] = useState(null);

  async function uploadingFile() {
    setIsLoading(true);

    const newFormData = new FormData();

    newFormData.append("verificationFile", uploadFile);

    try {
      const response = await fetch(
        `${baseUrl}bg-verification/${selectedStaff.staffDetails.id}/verify/` +
        uploadFileType,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
          body: newFormData,
          // Headers are not needed for FormData; fetch will automatically set 'Content-Type' as 'multipart/form-data'
        }
      );

      console.log("Response from backend:", response);

      if (response.ok) {
        // Changed to response.ok to handle all 2xx responses
        const result = await response.json();
        console.log("Response data:", result);
        setDocuments((prev) => [
          ...prev.filter(
            ({ type }) =>
              fileUploadTypes.find(({ name }) => name === type)?.file !==
              uploadFileType
          ),
          {
            type: fileUploadTypes.find(({ file }) => file === uploadFileType)
              ?.name,
            fileName:
              fileUploadTypes.find(({ file }) => file === uploadFileType)
                ?.name + " File",
            data: result?.data?.[uploadFileType + "_file"],
            isFolder: false,
            addedOn: formattedDate(result?.data?.updatedAt),
          },
        ]);

        openToast("File uploaded successfully", "success");
      } else {
        // Show error toast if response status is not 2xx
        openToast("An error occurred during file upload ", "error");
      }
    } catch (error) {
      console.error("Error in uploading file ", error);
      openToast("An error occurred during file upload", "error");
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  }

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  // console.log(staff);
  return (
    <div className="mt-[30px] w-[100%]">
      <div className="top-0 flex justify-between items-center bg-white shadow-cs pt-[14px] pr-[14px] pb-[14px] pl-[14px] rounded-md w-[100%]">
        <h3 className="font-medium">Documents</h3>
        <div>
          <button
            className="bg-[#27004a] p-[8px] rounded-lg text-[14px] text-[white]"
            onClick={onOpenModal}
          >
            Add Document
          </button>

          <Modal open={open} onClose={onCloseModal} center>
            <h2 className="border-[#dbdbdb] pb-[16px] border-b">
              Upload Document
            </h2>

            <div className="w-[100%]">
              <select
                value={uploadFileType}
                onChange={(e) => setUploadFileType(e.target.value)}
                className="border-1 mt-[24px] mb-[20px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
              >
                <option> Select a Document </option>
                <option value={"aadhaar"}> Aadhaar </option>
                <option value={"pan"}>PAN</option>
                <option value={"driving_license"}> Driving License </option>
                <option value={"voter_id"}> Voter Id </option>
                <option value={"uan"}> UAN </option>
                <option value={"address"}> Address </option>
              </select>

              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }} // Hide the input element
              />
              <button type="file"
                className="mb-[20px] w-full second-btn"
                onClick={handleUploadClick}
              >
                Upload Document
              </button>
            </div>

            <div className="flex justify-end items-center gap-[10px] border-[#dbdbdb] pt-[16px] border-t">
              <button
                className="first-btn"
                onClick={onCloseModal}
              >
                Cancel
              </button>
              <button
                disabled={isLoading}
                className={
                  " second-btn " +
                  (isLoading && "opacity-50 cursor-not-allowed animate-pulse")
                }
                onClick={uploadingFile}
              >
                OK
              </button>
            </div>
          </Modal>
        </div>
      </div>
      <div className="p-4 pr-0 pl-0 w-full">
        <div className="bg-white shadow-sm border rounded-lg">
          <div className="w-full overflow-auto">
            <table className="caption-bottom w-full text-sm">
              <thead className="bg-gray-50/75">
                <tr className="border-b transition-colors">
                  <th className="px-4 h-12 font-medium text-gray-500 text-left whitespace-nowrap align-middle">
                    Document Type
                  </th>
                  <th className="px-4 h-12 font-medium text-gray-500 text-left whitespace-nowrap align-middle">
                    File Name
                  </th>
                  <th className="px-4 h-12 font-medium text-gray-500 text-left whitespace-nowrap align-middle">
                    Added On
                  </th>
                  <th className="px-4 h-12 font-medium text-gray-500 text-left whitespace-nowrap align-middle">
                    Actions
                  </th>
                </tr>
              </thead>
              {!isLoadingData &&
                documents?.filter(({ data, isFolder }) => !isFolder && data)
                  ?.length > 0 && (
                  <tbody>
                    {documents
                      .filter((doc) => doc.data !== null)
                      .map((doc, index) => (
                        <tr
                          key={index}
                          className="hover:bg-gray-50/50 border-b transition-colors"
                        >
                          <td className="p-4 align-middle">{doc.type}</td>
                          <td className="p-4 align-middle">
                            <div className="flex items-center gap-2">
                              {doc.isFolder ? (
                                <svg
                                  className="w-5 h-5 text-yellow-400"
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
                                </svg>
                              ) : (
                                <svg
                                  className="w-5 h-5 text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                  />
                                </svg>
                              )}
                              {doc.fileName}
                            </div>
                          </td>
                          <td className="p-4 align-middle">
                            {doc.addedOn || "-"}
                          </td>
                          <td className="p-4 align-middle">
                            {!doc.isFolder && (
                              <button
                                onClick={() =>
                                  downloadFile(
                                    doc.data,
                                    selectedStaff.name + " " + doc.fileName
                                  )
                                }
                                className="inline-flex items-center font-medium text-blue-500 text-sm hover:text-blue-700"
                              >
                                Download
                                <svg
                                  className="ml-1 w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                  />
                                </svg>
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                )}
            </table>
          </div>
          {isLoadingData &&
            documents?.filter(({ data, isFolder }) => !isFolder && data)
              ?.length === 0 && (
              <div className="flex justify-center items-center py-2 w-full">
                <ClipLoader color={"#24007a"} size={50} />
              </div>
            )}
          {!isLoadingData &&
            documents?.filter(({ data, isFolder }) => !isFolder && data)
              ?.length === 0 && (
              <p className="py-2 w-full text-[#FF0000] text-center">
                No Document Found
              </p>
            )}
        </div>
      </div>
    </div>
  );
};

export default Documents;
